// Pazaryeri → Akik Pazar kapısı. Yönetici bu sayfaya girince ERP oturumuyla, yeniden giriş yapmadan
// Akik Pazar'a (e-ticaret kontrol paneli) geçer. ERP sunucusu 60 sn geçerli, tek kullanımlık, imzalı bir
// bilet üretir (backend/pazaryeriSso.js); tarayıcı biletle Akik Pazar'a yönlenir.
// ERP'nin kendi pazaryeri ayarları (Shopify bağlantısı, Trendyol, diğer pazaryerleri) /marketplace/ayarlar'da.
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Settings } from 'lucide-react';
import { API_URL } from '../config/api';

const PAZARYERI_URL = 'https://akikpazar.qubite.net';

export default function PazaryeriGateway() {
  const [error, setError] = useState('');
  const started = useRef(false);

  const go = async () => {
    setError('');
    try {
      const res = await fetch(`${API_URL}/integrations/pazaryeri/sso-ticket`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.url) throw new Error(data.error || (res.status === 401 ? 'Oturumunuzun süresi dolmuş; ERP\'ye yeniden giriş yapın.' : 'Akik Pazar açılamadı'));
      window.location.assign(data.url);
    } catch (e) {
      setError(e.message);
    }
  };

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    go();
  }, []);

  return (
    <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ maxWidth: 440, width: '100%', textAlign: 'center', background: '#fff', borderRadius: 16, padding: '32px 28px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        {error ? (
          <>
            <h2 style={{ margin: '0 0 8px', fontSize: '1.2rem' }}>Akik Pazar açılamadı</h2>
            <p style={{ color: '#616161', margin: '0 0 18px' }}>{error}</p>
            <button type="button" onClick={go} style={{ padding: '10px 18px', borderRadius: 10, border: 0, background: '#1a1a1a', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
              Tekrar dene
            </button>
          </>
        ) : (
          <>
            <div style={{ width: 34, height: 34, margin: '0 auto 14px', borderRadius: '50%', border: '3px solid #e3e3e3', borderTopColor: '#0f766e', animation: 'spin 0.8s linear infinite' }} />
            <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
            <p style={{ margin: 0, fontWeight: 600 }}>Akik Pazar açılıyor…</p>
            <p style={{ color: '#616161', fontSize: '0.88rem', margin: '6px 0 0' }}>ERP oturumunuzla giriş yapılıyor</p>
          </>
        )}
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 22, fontSize: '0.86rem' }}>
          <a href={`${PAZARYERI_URL}/giris`} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><ExternalLink size={14} /> E-posta ile giriş</a>
          <Link to="/marketplace/ayarlar" style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><Settings size={14} /> Pazaryeri ayarları (ERP)</Link>
        </div>
      </div>
    </div>
  );
}
